import React, { useState, useEffect } from 'react';
import Navbar from '../../components/navbar';
import Footer from '../../components/Footer';
import './ICAIMPage.css';

const stats = [
  { value: '104+', label: 'Research Papers', detail: 'High-quality papers on interdisciplinary subjects', icon: 'document' },
  { value: '5', label: 'Hackathon Winners', detail: 'Innovation Carnival in association with DCB Bank', icon: 'award' },
  { value: '4+', label: 'Global Partners', detail: 'AMC, MACCIA, NCSH & DCB Bank', icon: 'globe' },
  { value: 'Blended', label: 'Conference Mode', detail: 'Virtual & In-person participation', icon: 'group' },
  { value: 'COVID-19 Crisis', label: 'Vision Focus', detail: 'Sustainability in agriculture & medicine', icon: 'eye' },
];

const heroHighlights = ['COVID-19 Crisis', 'Healthcare on Cloud', 'Sustainable Agriculture', 'Ayushman Bharat Digital Mission', 'IoT & Blockchain'];

const themes = [
  {
    title: 'Agriculture',
    description: 'Carbon Sequestration, VegRoute logistics, drone technology, and boosting profitability for small holding dairy farmers.',
    tone: 'green',
  },
  {
    title: 'Healthcare (Medicine)',
    description: 'Healthcare on Cloud, Ayushman Bharat Digital Mission (ABDM), practical action points for digital health infrastructure.',
    tone: 'blue',
  },
  {
    title: 'Information Technology',
    description: 'IoT, Blockchain smart contracts, Cloud Security, Digital Cloud Wallets, and innovation-driven hackathons.',
    tone: 'violet',
  },
];

const preConferenceSchedule = [
  { date: '07-11 Feb 2022', time: 'Session', topic: 'Cloud Services during COVID-19 Crisis', speaker: 'Dr. Sanu Anand & Mr. Dhruv Sud (Cloudphysician Healthcare)' },
  { date: '07-11 Feb 2022', time: 'Session', topic: 'Opportunities in IT to empower Indian dairy farmer', speaker: 'Dr. Rajeshwaran, Professor, DMI' },
  { date: '07-11 Feb 2022', time: 'Session', topic: 'Agriculture Challenges During the Pandemic', speaker: 'Mr. Rajendra Bhat, Agro Consultant, Nisarg Mitra Farms' },
  { date: '07-11 Feb 2022', time: 'Session', topic: 'Innovation Carnival – Hackathon', speaker: 'Mr. Prasanna Lohar, Innovation Head, DCB Bank' },
  { date: '07-11 Feb 2022', time: 'Workshop', topic: 'Internet of Things (IoT) and Blockchain', speaker: 'TIMSCDR Faculty' }
];

const sessionChairs = [
  'Suresh Shan, Chief Innovation Officer, Mahindra & Mahindra',
  'Abhijit N. Banubakode, Principal, MET Institute of Computer Science',
  'Aparna Deshmukh, Head, Biotechnology, Thakur College of Science & Commerce',
  'Dineshkumar Singh, Group Leader, Social and Mobility Innovation, TCS'
];

const paperAwards = [
  { category: 'Faculty - Best Paper', title: 'Leveraging IT to enhance the profitability of small holding dairy farmers', authors: 'Dr. S Rajeshwaran and Dr. Vinita Gaikwad' },
  { category: 'Student - 1st Prize', title: 'Blockchain smart contracts: Applications, challenges and Solutions', authors: 'Anurag Dixit and Kevin Emmatty' },
  { category: 'Student - 2nd Prize', title: 'Irrigation in Agriculture using Drone Technology and IoT Sensors', authors: 'Ramchandra Desai and Anmol Dubey' }
];

const hackathonAwards = [
  { rank: '1st Position', title: 'Social Distancing – ID Card', authors: 'Mr. Mahesh Shinde' },
  { rank: '2nd Position', title: 'Solar Crypto Miner', authors: 'Mr. Krunal Rajan Shinde and Ms. Afsha Ashraf Shaikh' },
  { rank: '3rd Position', title: 'Buy Book in Half Price', authors: 'Mr. Kundan Yadav' },
  { rank: '4th Position', title: 'Warehouse booking Website: WHB', authors: 'Mr. MarkPhilipPereira' },
  { rank: '5th Position', title: 'Brain Drain', authors: 'Ms. Pinal Jain' }
];

const partners = ['AMC', 'MACCIA', 'NCSH', 'DCB Bank'];

// ---> UPDATED GALLERY IMAGES
const galleryCards = [
  { title: 'Inauguration Ceremony', src: '/ICAIM/ICAIM2022/imgi_3_icaim2021_1image.jpg' },
  { title: 'Keynote Speakers', src: '/ICAIM/ICAIM2022/imgi_4_icaim2022_2image.jpg' },
  { title: 'Panel Discussion', src: '/ICAIM/ICAIM2022/imgi_5_icaim2022_3image.jpg' },
  { title: 'Healthcare on Cloud', src: '/ICAIM/ICAIM2022/imgi_6_icaim2022_4image.jpg' }
];

// ---> UPDATED CAROUSEL IMAGES
const carouselImages = [
  '/ICAIM/ICAIM2022/imgi_4_icaim2022_2image.jpg',
  '/ICAIM/ICAIM2022/imgi_5_icaim2022_3image.jpg',
  '/ICAIM/ICAIM2022/imgi_6_icaim2022_4image.jpg'
];

const icon = (kind) => {
  const common = { fill: 'none', stroke: 'currentColor', strokeWidth: '1.9', strokeLinecap: 'round', strokeLinejoin: 'round' };
  if (kind === 'calendar') return <svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="5" width="18" height="16" rx="2" {...common} /><path d="M8 3v4M16 3v4M3 10h18" {...common} /></svg>;
  if (kind === 'location') return <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 21s6-5.4 6-11a6 6 0 1 0-12 0c0 5.6 6 11 6 11Z" {...common} /><circle cx="12" cy="10" r="2.5" {...common} /></svg>;
  if (kind === 'document') return <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 3h7l4 4v14H7V3Z" {...common} /><path d="M14 3v5h5M10 13h6M10 17h6M10 9h2" {...common} /></svg>;
  if (kind === 'user') return <svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="8" r="4" {...common} /><path d="M5 21c1.2-4 4-6 7-6s5.8 2 7 6" {...common} /></svg>;
  if (kind === 'globe') return <svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9" {...common} /><path d="M3 12h18M12 3c2.2 2.4 3.3 5.4 3.3 9S14.2 18.6 12 21M12 3c-2.2 2.4-3.3 5.4-3.3 9S9.8 18.6 12 21" {...common} /></svg>;
  if (kind === 'group') return <svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="9" cy="9" r="3.2" {...common} /><circle cx="17" cy="10" r="2.6" {...common} /><path d="M3.5 21c.9-3.9 3-6 5.5-6s4.6 2.1 5.5 6M14.5 16c2.4.2 4.2 1.9 5 5" {...common} /></svg>;
  if (kind === 'eye') return <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M2.5 12s3.6-6 9.5-6 9.5 6 9.5 6-3.6 6-9.5 6-9.5-6-9.5-6Z" {...common} /><circle cx="12" cy="12" r="3" {...common} /></svg>;
  if (kind === 'arrow') return <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6" {...common} /></svg>;
  if (kind === 'leaf') return <svg width="36" height="36" stroke="#ffffff" viewBox="0 0 24 24" aria-hidden="true"><path d="M5 14c0-5.5 4.5-10 10-10h4v4c0 5.5-4.5 10-10 10H5v-4Z" {...common} /><path d="M8 16c3-5 6-7 11-10" {...common} /></svg>;
  if (kind === 'medical') return <svg width="36" height="36" stroke="#ffffff" viewBox="0 0 24 24" aria-hidden="true"><rect x="5" y="3" width="14" height="18" rx="2" {...common} /><path d="M12 8v8M8 12h8" {...common} /></svg>;
  if (kind === 'chip') return <svg width="36" height="36" stroke="#ffffff" viewBox="0 0 24 24" aria-hidden="true"><rect x="7" y="7" width="10" height="10" rx="2" {...common} /><path d="M9 1v4M15 1v4M9 19v4M15 19v4M1 9h4M1 15h4M19 9h4M19 15h4" {...common} /></svg>;
  if (kind === 'download') return <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M7 10l5 5 5-5M12 15V3" {...common} /></svg>;
  if (kind === 'award') return <svg width="36" height="36" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="8" r="5" {...common} /><path d="M8.5 13.5 7 21l5-3 5 3-1.5-7.5" {...common} /></svg>;
  return null;
};

const Icaim22 = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prevSlide) => (prevSlide + 1) % carouselImages.length);
    }, 3500);
    return () => clearInterval(timer);
  }, []);

  const handleScrollToSection = (event, sectionId) => {
    event.preventDefault();
    const target = document.getElementById(sectionId);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <div className="icaim25Page icaim24Page">
      <Navbar />
      <main className="icaim25Main">
        <section className="icaim25Hero">
          <div className="icaim25HeroShell glass-panel-dark">
            <div className="icaim25HeroGrid" id="icaim25-content">
              <div className="icaim25HeroCopy">
                <span className="icaim25HeroKicker">ICAIM 2022</span>
                <h1 className="icaim25HeroTitle">
                  IT for Sustainability in COVID-19 Crisis
                </h1>
                <p className="icaim25HeroSubtitle">
                  Theme: "Leveraging Information Technology for Sustainability in Agriculture and Medicine – COVID 19 Crisis"
                </p>

                <div className="icaim25HeroHighlights" aria-label="Conference focus areas">
                  {heroHighlights.map((highlight) => (
                    <span key={highlight}>{highlight}</span>
                  ))}
                </div>

                <div className="icaim25HeroMetaInline">
                  <div className="icaim25MetaItemInline">
                    <span className="icaim25MetaIconInline">{icon('calendar')}</span>
                    <span>12 - 13 February 2022</span>
                  </div>

                  <span className="icaim25MetaSeparator">|</span>

                  <div className="icaim25MetaItemInline">
                    <span className="icaim25MetaIconInline">{icon('location')}</span>
                    <span>TIMSCDR, Mumbai (Blended Mode)</span>
                  </div>
                </div>

                <div className="icaim25HeroActions">
                  <a
                    href="#overview"
                    className="icaim25PrimaryButton text-center"
                    style={{ textDecoration: 'none' }}
                    onClick={(event) => handleScrollToSection(event, 'overview')}
                  >
                    <span>Explore Conference</span>
                    <span className="icaim25ButtonIcon">{icon('arrow')}</span>
                  </a>
            <a
                    href="/pdf/ICAIM/Proceeding-2022.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="icaim25SecondaryButton text-center"
                    style={{ textDecoration: 'none' }}
                  >
                    <span>View Publications</span>
                    <span className="icaim25ButtonIcon">{icon('document')}</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="icaim25StatsSection" id="about">
          <div className="icaim25StatsGrid glass-panel-light">
            {stats.map((stat, index) => (
              <div className="icaim25StatCard" key={stat.label}>
                <div className={`icaim25StatIcon statTone${index + 1}`}>{icon(stat.icon)}</div>
                <div>
                  <div className="icaim25StatValue">{stat.value}</div>
                  <div className="icaim25StatLabel">{stat.label}</div>
                  <div className="icaim25StatDetail">{stat.detail}</div>
                </div>
              </div>
            ))}
          </div>
        </section>

        <section className="icaim25AboutSection" id="overview">
          <div className="icaim25AboutGrid">
            <div className="icaim25SectionIntro">
              <span className="icaim25SectionTag">Conference Overview</span>
              <h2>Tackling the Pandemic through Tech & Sustainability.</h2>
              <p>
                Thakur Institute of Management Studies, Career Development and Research (TIMSCDR) organized <strong>ICAIM 2022</strong> on 12-13 February 2022. Set against the backdrop of the pandemic, the conference explored how IT solutions can sustain and advance Agriculture and Medicine during the <strong>COVID-19 Crisis</strong>.
              </p>
              <p>
                Arranged in association with AMC, MACCIA, and the Nordic Center for Sustainable Healthcare (NCSH), the event brought together leading experts to present action points on digital healthcare, cloud infrastructure, and innovative agritech.
              </p>
            </div>

            <div className="icaim25StageCard glass-panel-light" aria-hidden="true">
              <div className="icaim25StageHeader">ICAIM 2022</div>
              <div className="icaim25StageScreen">
                <div className="icaim25CarouselTrack">
                  {carouselImages.map((img, index) => (
                    <img
                      key={index}
                      src={img}
                      alt={`Conference slide ${index + 1}`}
                      className={`icaim25CarouselImg ${index === currentSlide ? 'active' : ''}`}
                    />
                  ))}
                  <div className="icaim25CarouselOverlay"></div>
                </div>
                <div className="icaim25StageAudience" />
              </div>
            </div>
          </div>
        </section>

        <section className="icaim25ThemeSection">
          <div className="icaim25CenteredHeading">
            <span className="icaim25SectionTag">Theme Focus</span>
          </div>
          <div className="icaim25ThemeGrid">
            {themes.map((theme, index) => (
              <article className={`icaim25ThemeCard tone-${theme.tone}`} key={theme.title}>
                <div className="icaim25ThemeCardIcon">
                  {icon(index === 0 ? 'leaf' : index === 1 ? 'medical' : 'chip')}
                </div>
                <h3>{theme.title}</h3>
                <p>{theme.description}</p>
              </article>
            ))}
          </div>
        </section>

        <section className="icaim25NarrativeSection" id="events">
          <div className="icaim25CenteredHeading" style={{ marginTop: '50px' }}>
            <span className="icaim25SectionTag">Event Highlights</span>
          </div>
          <div className="icaim25NarrativeGrid">
            <article className="icaim25NarrativeCard glass-panel-light">
              <div className="icaim25PanelHeader">
                <span className="icaim25PanelTag" style={{ color: 'var(--icaim-accent)' }}>Day 1 - 12 February 2022</span>
                <h3 style={{ marginTop: '8px', fontSize: '1.6rem', color: 'var(--icaim-text)' }}>Inauguration & Agriculture Focus</h3>
              </div>
              <p>
                Inaugurated by Chief Guest <strong>Mr. Lalit Gandhi</strong> (President, MACCIA) alongside dignitaries including Dr. Debiprasad Mishra, Mr. Johannes Brundin, Dr. Suresh Shan, and Mr. Sudhanshu Ojha. The Conference Proceedings featuring 104 research papers were unveiled.
              </p>
              <p>
                Speaker sessions featured <strong>Mr. Chandrasekhar Bhadsavle</strong> on Carbon Sequestration through SRT, <strong>Mr. Shyam Prashad Rajasekaran</strong> on Using IT in Agriculture (VegRoute), and <strong>Dr. N. Anandaraja</strong> presenting advanced IT applications for agriculture.
              </p>
            </article>

            <article className="icaim25NarrativeCard glass-panel-light">
              <div className="icaim25PanelHeader">
                <span className="icaim25PanelTag" style={{ color: 'var(--icaim-accent)' }}>Day 2 - 13 February 2022</span>
                <h3 style={{ marginTop: '8px', fontSize: '1.6rem', color: 'var(--icaim-text)' }}>Digital Health & Cloud Medicine</h3>
              </div>
              <p>
                Graced by Chief Guest <strong>Dr. Sushmita Bhatnagar</strong> (President, AMC). A major highlight was the unveiling of the book <em>"Healthcare on Cloud"</em>, a joint effort of TIMSCDR and AMC detailing how doctors can utilize cloud services during the pandemic.
              </p>
              <p>
                Dr. Bhatnagar sensitized the audience on the <strong>Ayushman Bharat Digital Mission (ABDM)</strong>. A fervent panel discussion on "Digital Health Mission – Practical Action Points" followed, moderated by Dr. Mukesh Gupta and Dr. Vikrant Desai, exploring technology's pivotal role in Indian healthcare infrastructure.
              </p>
            </article>
          </div>
        </section>

        <section className="icaim25FeatureSection" id="speakers">
          <div className="icaim25FeatureGrid">
            <article className="icaim25DarkPanel glass-panel-dark">
              <div className="icaim25PanelHeader">
                <span className="icaim25PanelTag">Workshops &amp; Special Events</span>
                <h2>Applied learning and skill development.</h2>
              </div>
              <div className="icaim25WorkshopGrid">
                <div className="icaim25WorkshopCard highlight-green">
                  <h3>Doctor&apos;s Workshop: Healthcare on Cloud</h3>
                  <p>Conducted by TIMSCDR faculty, guiding doctors on providing uninterrupted medical services during the COVID-19 pandemic using Cloud technology.</p>
                  <ul>
                    <li>Utilizing Cloud Services for remote care</li>
                    <li>Managing Patient Data effectively</li>
                    <li>Addressing Cloud Security Issues</li>
                    <li>Implementation of Digital Cloud Wallets</li>
                  </ul>
                </div>
                <div className="icaim25WorkshopCard highlight-orange">
                  <h3>Innovation Carnival – Hackathon</h3>
                  <p>In association with DCB Bank. Students presented project ideas pertaining to sustainable development goals, judged by Mr. Prasana Lohar, Chief Innovation Officer.</p>
                  <div className="icaim25JudgesBlock">
                    <strong>Pre-Conference Highlights</strong>
                    <span>IoT and Blockchain Workshop for Students</span>
                    <span>Cloud Services during COVID-19 Crisis</span>
                  </div>
                </div>
              </div>
            </article>

            <article className="icaim25NarrativeCard glass-panel-light" id="pre-conference">
              <div className="icaim25PanelHeader">
                <span className="icaim25PanelTag" style={{ color: 'var(--icaim-primary)' }}>Pre-Conference</span>
                <h3 style={{ marginTop: '8px', fontSize: '1.6rem', color: 'var(--icaim-text)' }}>Expert Sessions</h3>
              </div>
              <p style={{ marginBottom: '16px' }}>
                Conducted for students from 7-11 February 2022, focusing on technological adaptation in crisis and innovation.
              </p>
              <div className="icaim25TableWrap glass-table">
                <table className="icaim25Table">
                  <thead>
                    <tr>
                      <th>Date</th>
                      <th>Topics</th>
                      <th>Speaker Details</th>
                    </tr>
                  </thead>
                  <tbody>
                    {preConferenceSchedule.map((session, i) => (
                      <tr key={i}>
                        <td><strong>{session.date}</strong><br /><span style={{ fontSize: '0.85em', color: 'var(--icaim-text-muted)' }}>{session.time}</span></td>
                        <td>{session.topic}</td>
                        <td>{session.speaker}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </article>
          </div>
        </section>

        <section className="icaim25ResearchSection" id="awards">
          <div className="icaim25CenteredHeading" style={{ marginTop: '80px' }}>
            <span className="icaim25SectionTag">Proceedings & Recognitions</span>
            <h2 style={{ fontSize: '2.2rem', marginTop: '10px' }}>104 Research Papers & Hackathon Innovations</h2>
            <p style={{ color: 'var(--icaim-text-muted)', maxWidth: '700px', margin: '10px auto' }}>
              Selected after a rigorous review process and presented before distinguished professionals from Agriculture, Healthcare, and IT sectors.
            </p>
          </div>

          <div className="icaim25SessionChairs" style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', justifyContent: 'center', marginBottom: '40px' }}>
            {sessionChairs.map((chair, i) => (
              <span key={i} className="icaim25Badge">{chair}</span>
            ))}
          </div>

          <div className="icaim25AwardsStack">
            <article className="icaim25NarrativeCard glass-panel-light">
              <h3 style={{ color: 'var(--icaim-primary)', marginBottom: '16px' }}>Research Paper Awards</h3>
              <div className="icaim25TableWrap glass-table">
                <table className="icaim25Table">
                  <thead>
                    <tr>
                      <th>Award Category</th>
                      <th>Research Paper Title</th>
                      <th>Authors</th>
                    </tr>
                  </thead>
                  <tbody>
                    {paperAwards.map((award, i) => (
                      <tr key={i}>
                        <td><strong style={{ color: award.category.includes('Best') || award.category.includes('1st') ? 'var(--icaim-accent)' : 'inherit' }}>{award.category}</strong></td>
                        <td>{award.title}</td>
                        <td>{award.authors}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </article>

            <article className="icaim25NarrativeCard glass-panel-light">
              <h3 style={{ color: 'var(--icaim-primary)', marginBottom: '16px' }}>Innovation Carnival – Hackathon Winners</h3>
              <div className="icaim25TableWrap glass-table">
                <table className="icaim25Table">
                  <thead>
                    <tr>
                      <th>Position</th>
                      <th>Proposed Idea</th>
                      <th>Student(s)</th>
                    </tr>
                  </thead>
                  <tbody>
                    {hackathonAwards.map((award, i) => (
                      <tr key={i}>
                        <td><strong style={{ color: award.rank.includes('1st') ? 'var(--icaim-accent)' : 'inherit' }}>{award.rank}</strong></td>
                        <td>{award.title}</td>
                        <td>{award.authors}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </article>
          </div>
        </section>

        <section className="icaim25PublicationsSection" id="publications" style={{ padding: '60px 20px', background: 'var(--icaim-bg-alt)' }}>
          <div className="icaim25CenteredHeading">
            <span className="icaim25SectionTag">Publications</span>
            <h2 style={{ fontSize: '2rem', marginTop: '10px' }}>Healthcare on Cloud & ICAIM 2022 Journal</h2>
            <p style={{ color: 'var(--icaim-text-muted)', maxWidth: '600px', margin: '15px auto 30px' }}>
              Access the joint "Healthcare on Cloud" book released during the conference, alongside the official published journal featuring interdisciplinary research papers.
            </p>
            <div style={{ display: 'flex', gap: '15px', justifyContent: 'center', flexWrap: 'wrap' }}>
              <a 
                href="/path/to/Healthcare-on-Cloud-Book.pdf" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="icaim25PrimaryButton" 
                style={{ display: 'inline-flex', alignItems: 'center', gap: '10px', textDecoration: 'none' }}
              >
                <span className="icaim25ButtonIcon" style={{ margin: 0 }}>{icon('download')}</span>
                <span>Download "Healthcare on Cloud" Book</span>
              </a>
              <a 
                href="/path/to/ICAIM-2022-Journal-Publication.pdf" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="icaim25SecondaryButton" 
                style={{ display: 'inline-flex', alignItems: 'center', gap: '10px', textDecoration: 'none' }}
              >
                <span className="icaim25ButtonIcon" style={{ margin: 0 }}>{icon('document')}</span>
                <span>Download ICAIM 2022 Journal</span>
              </a>
            </div>
          </div>
        </section>

        <section className="icaim25PartnersSection">
          <div className="icaim25CenteredHeading">
            <span className="icaim25SectionTag">Our Partners &amp; Associations</span>
          </div>
          <div className="icaim25PartnersGrid">
            {partners.map((partner) => (
              <div className="icaim25PartnerCard glass-panel-light" key={partner}>
                <div className="icaim25PartnerMark">{partner.charAt(0)}</div>
                <div className="icaim25PartnerName">{partner}</div>
              </div>
            ))}
          </div>
        </section>

        <section className="icaim25GallerySection" id="gallery">
          <div className="icaim25CenteredHeading">
            <span className="icaim25SectionTag">Glimpses From ICAIM 2022</span>
          </div>
          <div className="icaim25GalleryGrid">
            {galleryCards.map((card, index) => (
              <div className={`icaim25GalleryCard gallery-${index + 1}`} key={card.title}>
                <img
                  src={card.src}
                  alt={card.title}
                  style={{ width: '100%', height: 'auto', borderRadius: '14px', objectFit: 'cover' }}
                />
                <span>{card.title}</span>
              </div>
            ))}
          </div>
        </section>

      </main>

      <Footer />
    </div>
  );
};

export default Icaim22;